import MaintenanceReport from "./MaintenanceReport";

export default MaintenanceReport;